import React from "react";

import { Box, Flex, Text } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import Informacao from "../../../pages/ServicosAcolhimento/RedeReferencia/Informacao";

export const RedeReferencia = ({ data }) => {
  return data ? (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#DDEBEA"
          title="Rede de Referência do Serviço"
          mt="15px"
          py="12px"
          mtDivider="5px"
        >
          <Informacao
            title="TIPO DE REDE DE REFERÊNCIA"
            info="ÓRGÃO"
            bgColor="#ECEFF1"
            mt="20px"
            isHead={true}
          />
          <Informacao
            title="Conselho Tutelar"
            info={data.conselhoTutelar.nome}
            bgColor="#FFFFFF"
          />
          <Informacao title="CREAS" info={data.crea.nome} bgColor="#F9FAFB" />
          <Informacao title="CRAS" info={data.cras.nome} bgColor="#FFFFFF" />
          <Informacao title="UBS" info={data.ubs} bgColor="#F9FAFB" />
          <Informacao
            title="CAPS"
            info={data.cpas ? data.cpas : "Não se aplica"}
            bgColor="#FFFFFF"
          />
          <Informacao
            title="CAPSi"
            info={data.capsi ? data.capsi : "Não se aplica"}
            bgColor="#F9FAFB"
          />
          <Informacao
            title="CAPSad"
            info={data.capsad ? data.capsad : "Não se aplica"}
            bgColor="#FFFFFF"
          />
          <Informacao
            title="Secretaria Municipal de Educação"
            info={
              data.secretariaMunicipal
                ? data.secretariaMunicipal.nome
                : "Não se aplica"
            }
            bgColor="#F9FAFB"
          />
          {data.coordenadoria && (
            <Informacao
              title="Coordenadoria Regional de Educação"
              info={data.coordenadoria.nome}
              bgColor="#FFFFFF"
            />
          )}
          <Informacao
            title="Coordenadoria Educacional/Diretoria Regional estadual"
            info={
              data.diretoriaRegional
                ? data.diretoriaRegional.nome
                : "Não se aplica"
            }
            bgColor={data.coordenadoria ? "#F9FAFB" : "#FFFFFF"}
          />
          <Box className="break-page">
            <Text
              fontWeight="700"
              fontSize="14px"
              lineHeight="19.6px"
              color="#169499"
              mt="25px"
            >
              RESPONSÁVEL PELAS INFORMAÇÕES:
            </Text>
            <Informacao
              title="NOME"
              info="FUNÇÃO/CARGO"
              bgColor="#ECEFF1"
              mt="10px"
              isHead={true}
            />
            <Informacao
              title={data.membroResponsavel.nome}
              info={
                data.membroResponsavel.tipoEquipeAcolhimento.nomeEquipe ===
                "Equipe de Referência"
                  ? data.membroResponsavel.funcaoEquipeAcolhimento.nomeFuncao
                  : data.membroResponsavel.cargoEquipeAcolhimento.nomeCargo
              }
              bgColor="#FFFFFF"
            />
          </Box>
        </Group>
      </Flex>
    </Box>
  ) : (
    <Box className="break-page">
      <Group
        bgColor="#DDEBEA"
        title="Rede de Referência do Serviço"
        mt="15px"
        py="12px"
        mtDivider="5px"
      />
    </Box>
  );
};
